export default {
  state: {
    msg: {
      enabled: true,
      timeout: 10000,
      show: false,
      data: {
        text: '',
        type: 'success',
      },
      reloadableKey: new Date().getTime(),
    },
  },
  mutations: {
    refreshReloadableMsgKey(state) {
      state.msg.reloadableKey = new Date().getTime()
    },
    hidemsg(state) {
      state.msg.show = false
      state.msg.data.text = ''
    },
    showmsg(state, msg) {
      this.commit('refreshReloadableMsgKey');
      state.msg.data = Object.assign({}, state.msg.data, msg);
      state.msg.show = true
    },
    tooglemsg(state, show) {
      state.msg.show = show
    },
    enableMsg(state, status) {
      state.msg.enabled = status
    },
    showDefaultErrorMsg(state) {
      this.commit('showmsg', {
        text: 'Erro ao carregar',
        type: 'error'
      })
    }
  },
}